/**
 * Tailwind background color class per project state.
 * Pair with getProjectStateTextColor() if you need a matching text color.
 */
export const getProjectStateColor = (state?: string | null): string => {
  switch (state?.toLowerCase()) {
    case 'completed':
      return 'bg-complete-project';
    case 'ongoing':
      return 'bg-ongoing-project';
    case 'abandoned':
      return 'bg-abandoned-project';
    case 'delayed':
      return 'bg-delayed-project';
    case 'bidding':
      return 'bg-bidding-project';
    case 'draft':
      return 'bg-draft-project';
    case 'behind':
      return 'bg-behind-project';
    default:
      return 'bg-gray-500';
  }
};
